<template>
  <div class="mt-8">
    <px-view-module-header module-name="Cotações" :breadcrumbs="breadcrumbs"/>
    <v-card class="rounded-card card-shadow mt-8">
      <v-card-text class="text--primary">
        <px-view-header-title title="Cotações"/>
        <div class="mt-5">
          <listagem-cotacao-header :on-click-refresh="onClickRefresh"
                                   :on-change-filter="onChangeFilter"
                                   @change="onChangeFilter"/>
          <lista-cotacao :cotacoes="cotacoes" :loading="loading"
                         :on-change-options="onChangeOptions"
                         :options-list="optionsList"
                         @update="onClickRefresh"/>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import CotacoesListagemService from '@/modules/cotacoes/cotacoes-listagem-service';
import ListaCotacao from './ListaCotacao.vue';
import ListagemCotacaoHeader from './ListagemCotacaoHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      cotacoes: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      loading: false,
      breadcrumbs: [
        { text: 'Cotações' },
        { text: 'Cotações' },
      ],
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemCotacao', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.resetPage();
      this.getCotacoes();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCotacoes();
    },
    onClickRefresh() {
      this.getCotacoes();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCotacoes() {
      this.loading = true;
      this.listOptions.filter = this.stringFilter;
      const {
        limit,
        offset,
      } = this.listOptions;
      return CotacoesListagemService.getCotacoes({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.cotacoes = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    ListaCotacao,
    ListagemCotacaoHeader,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
};
</script>
